import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function LeadSection() {
  return <section className="pt-[20px] pb-[20px]" data-id="element-60">
      <FadeIn data-id="element-61">
        <h1 className="md:text-4xl font-bold text-gray-900 mb-8 text-left max-w-3xl mx-auto text-[24px]" data-id="element-62">
          The Secret Your Dentist Knows About Why Your Teeth Keep Getting Worse
          — And Why They’ve Never Once Brought It Up In The Chair...
        </h1>

        <div className="max-w-2xl mx-auto mb-3 rounded-xl overflow-hidden shadow-md" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/a7R8UdNyE8wSE4UcEJHLMv/hf_20260327_052200_77cbb630-1c53-41f9-a765-53ff87618754_(2)_(1).png" alt="The impact of dental health on confidence" className="w-full h-auto object-cover" data-id="element-64" />
        </div>

        <div className="flex items-center justify-center space-x-4 font-sans text-sm text-gray-600 mt-[0px] mb-[0px]" data-id="element-65">
          <div className="flex items-center" data-id="element-66">
            <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center text-teal-700 font-bold mr-3" data-id="element-67">
              EC
            </div>
            <div data-id="element-68">
              <p className="font-semibold text-gray-900" data-id="element-69">By Dr. Emily Chen</p>
              <p data-id="element-70">Doctor of Dental Medicine</p>
            </div>
          </div>
        </div>
      </FadeIn>

      <div className="editorial-text max-w-2xl mx-auto" data-id="element-71">
        <FadeIn delay={0.1} data-id="element-72">
          <p className="text-2xl italic text-teal-800 leading-relaxed mb-10 pl-6 border-l-4 border-teal-500 bg-teal-50/50 py-4 pr-4 rounded-r-lg font-[900]" data-id="element-73">
            If you brush twice a day, floss, maybe even use a water flosser —
            and you're still getting cavities, still hearing bad news at the
            dentist, still watching your gums recede — you’re going to want to
            read this…
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-74">
          <p className="pt-[20px]" data-id="element-75">
            In 25 years of practicing dentistry — and as a wife and mother —
            I’ve sat across from thousands of patients who came in convinced
            they were just one of the ‘unlucky’ ones.
          </p>
          <p className="text-[20px] font-[700]" data-id="element-76">
            But upon a closer look, their teeth were unknowingly facing a
            “Biofilm Crisis”.
          </p>
          <p data-id="element-77">
            A highly resilient - and invisible - bacterial fortress that no
            toothpaste, mouthwash, or treatment can effectively eliminate.
          </p>
          <p data-id="element-78">
            The frustrating part is that it has nothing to do with age, diet,
            genetics…
          </p>
          <p data-id="element-79">
            And everything to do with the way modern dentistry has been trained
            to treat the mouth…
          </p>
          <p data-id="element-80">
            Because as it turns out, the very advice we've been taught to follow
            for years wasn't just ignoring the problem… It was creating it.
          </p>
          <p data-id="element-81">
            How else can you explain the fact that our ancestors maintained
            perfectly healthy teeth thousands of years ago - without having any
            concept of toothbrushes or oral care?
          </p>
          <p data-id="element-82">
            Because the Biofilm Crisis is a modern problem — one our ancestors
            never faced — since nobody was selling them the products that cause
            it.
          </p>
          <p data-id="element-83">
            But how can you tell if you’re unknowing facing a Biofilm Crisis?
          </p>
          <p data-id="element-84">
            In this article, we'll explore seven warning signs that your mouth
            may already be losing the battle against a Biofilm Crisis — and what
            you can do to stop it before the damage becomes irreversible.
          </p>
        </FadeIn>
      </div>
    </section>;
}